import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";
import Menu from "./Menu";
import LevelMap from "./pages/LevelMap";
import HowToPlay from "./pages/HowToPlay";
import LevelOne from "./pages/LevelOne";
import LoadingScreen from "./components/LoadingScreen";
import Onboarding from "./components/Onboarding";
import PayScreen from "./components/PayScreen"; 
import PaymentSuccessScreen from "./components/PaymentSuccessScreen"; 

function AppWrapper() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading screen delay
    const timer = setTimeout(() => {
      setLoading(false);
      const seenOnboarding = localStorage.getItem("seenOnboarding");
      if (!seenOnboarding) {
        navigate("/onboarding");
      } else {
        navigate("/");
      }
    }, 1500);

    return () => clearTimeout(timer);
  }, [navigate]);

  return loading ? <LoadingScreen /> : null;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/loading" element={<AppWrapper />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/" element={<Menu />} />
        <Route path="/levels" element={<LevelMap />} />
        <Route path="/howtoplay" element={<HowToPlay />} />
        <Route path="/level/1" element={<LevelOne />} />
        <Route path="/pay" element={<PayScreen />} />
        <Route path="/success" element={<PaymentSuccessScreen />} />

        {/* Default route fallback - redirect all unmatched routes to /loading */}
       <Route path="*" element={<Navigate to="/loading" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
